class Storage {

    constructor(data) {
        this.isLocalStorageNameSupported;
        var testKey = 'test', storage = localStorage;

        try
        {
            localStorage.setItem(testKey, '1');
            localStorage.removeItem(testKey);
            return this.isLocalStorageNameSupported =  true;
             
        }
        catch (error)
        {
            this.isLocalStorageNameSupported = false;
            return false;
        }
    }
    
    
    setItem(label,value){
        if(this.isLocalStorageNameSupported){
            localStorage.setItem(label,value);
        }
        else{
            // alert(label +': '+ value);
            Cookies.set(label, value);
        }
        return true;
    }
    
    getItem(label){
        if(this.isLocalStorageNameSupported){
           return localStorage.getItem(label);
        }
        else{
            // alert(Cookies.get(label))
           return  Cookies.get(label);
        }
    }

    removeItem(label){
        if(this.isLocalStorageNameSupported){
            return localStorage.removeItem(label);
        }
        else{
            return  Cookies.remove(label);
        }
        return true;
    }




}